// extracted by mini-css-extract-plugin
export var bodySections = "_5r-8";
export var gray = "_5r-7";
export var green = "_5r-4";
export var iconContainer = "_5r-9";
export var iconWidgetContainer = "_5r-1";
export var phoneIcon = "_5r-2";
export var red = "_5r-5";
export var statusDot = "_5r-3";
export var widgetContainer = "_5r-0";
export var yellow = "_5r-6";